__webpack_require__.p = "/views-design-feedback/onboarding/";